import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  LinearProgress,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import states from "../json/state.json";
import ReCAPTCHA from "react-google-recaptcha";
// import dynamic from "next/dynamic";

// import ReCAPTCHA from "react-google-recaptcha";

const FindDivineModal = ({ newwOpen, setNewwOpen }) => {
  // const recaptchaRef = React.createRef();
  const recaptchaRef = React.createRef();
  const [snackbarStare, setSnackbarStare] = useState(false);
  const handleClose = () => setSnackbarStare(false);

  const handleClick = () => {
    setSnackbarStare(true);
  };

  const [user, setUser] = useState({});
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState({});
  const handleNewwClose = () => {
    setNewwOpen(false);
  };

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "state") {
      setError({ ...error, [name]: undefined });
    }
    setUser({ ...user, [name]: value });
  };
  const [checkboxValue, setChecboxValue] = useState("");
  const [interestedin, setInterestedin] = useState("");
  const [message, setMessage] = useState("");

  const [interestValueTrue, setInterestValueTrue] = useState(false);
  const [interestValueFlase, setInterestValueFlase] = useState(false);
  const [interestValueBoth, setInterestValueBoth] = useState(false);

  const handelCheckbox = (e, type) => {
    console.log(e, "handelCheckbox", type);

    if (type == "astrology") {
      setInterestedin("astrology");
      setInterestValueFlase(false);
      setInterestValueTrue(true);
      setInterestValueBoth(false);
    } else if (type == "both") {
      setInterestedin("both");
      setInterestValueFlase(true);
      setInterestValueTrue(true);
      setInterestValueBoth(true);
    } else {
      setInterestedin(type);
      setInterestValueFlase(true);
      setInterestValueTrue(false);
      setInterestValueBoth(false);
    }
    // setChecboxValue(e.target.value);
    console.log(e.target.value, "e============");
    let value = e.target.value;
    let interested_in = [];
    setUser({ ...user, interested_in: value });
    if (value == "") {
      setError({ ...error, interested_in: undefined });
    }
  };

  useEffect(() => {
    console.log(checkboxValue, "checkboxValue===>>>");
  }, []);

  const [bookingValue, setBookingValue] = useState("");

  const bookingCallfunc = (event) => {
    console.log("dggfhjh=====", event);
    setBookingValue(event.target.value);
    console.log("dggfhjh=====", event.target.value);
  };

  useEffect(() => {
    console.log("vaue-=======", bookingValue);
  }, []);

  // ==========================token==============================
  // const [tokenGen, setTokenGen] = useState("");

  // const handleInputCheck = (e) => {
  //   console.log(e, "svhfjfdlf=>>>>");
  //   setTokenGen(e);
  // };

  // useEffect(() => {
  //   console.log("tokenGen===========", tokenGen);
  // }, [JSON.stringify(tokenGen)]);
  // ==========================token==============================

  const phoneFormatting = (event) => {
    // console.log("event", event)
    if (event.target.value.split("").length <= 14) {
      let formatted = formatPhoneText(event.target.value);
      let name = event.target.name;
      user.phone = formatted;
      setUser({ ...user, [name]: formatted });
    }
  };

  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");

    if (value.length > 3 && value.length <= 6)
      value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6)
      value =
        "(" +
        value.slice(0, 3) +
        ")" +
        " " +
        value.slice(3, 6) +
        "-" +
        value.slice(6);
    return value;
  }

  const [tokenGen, setTokenGen] = useState("");
  useEffect(() => {
    console.log("tokenGen===========", tokenGen);
  }, [JSON.stringify(tokenGen)]);

  useEffect(() => {
    console.log(user);
  }, [user]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorObject = {};

    if (tokenGen == "") {
      errorObject.tokenGen = "*Prove you are not a robot";
    }

    if (!user?.firstname) {
      errorObject.firstname = "First Name is Required";
    }
    if (!user?.email) {
      errorObject.email = "Email is Required";
    } else if (!/\S+@\S+\.\S+/.test(user.email)) {
      errorObject.email = "* Invalid email format";
    }
    if (!user?.lastname) {
      errorObject.lastname = "Last Name is Required";
    }
    if (!user?.city) {
      errorObject.city = "City is Required";
    }
    if (!user?.phone) {
      errorObject.phone = " Telephone Number is Required";
    }

    if (!user?.state) {
      errorObject.state = "State is Required";
    }

    if (!user?.best_time_to_call) {
      errorObject.best_time_to_call = "Best Time To Call is Required";
    }

    // if (!user?.comments) {
    //   errorObject.comments = "Questions Or Comments is Required"
    // }
    if (!user?.zip) {
      errorObject.zip = "Zip is Required";
    }
    if (user) {
      user.type = "Find A Diviner";
    }
    if (interestedin) {
      user.interested_in = interestedin;
    }
    if (!user?.interested_in) {
      errorObject.interested_in = "Please Choose One";
    }
    if (!user?.interested_in) {
      errorObject.interested_in = "Please Choose One";
    }
    if (Object.keys(errorObject).length > 0) {
      setError(errorObject);
      console.log("error exeist", errorObject);
    } else {
      setUser({ ...user, ["phone"]: user.phone.replace(/^\((.+)\)$/, "") });
      setLoader(true);

      setError({});
      let requestOptions = {
        method: "POST",
        // mode:'no-cors',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user),
      };
      console.log("user=========>", user);
      try {
        let req = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}membership/addedit`,
          requestOptions
        );
        console.log("req", req);
        let res = await req.json();
        if (res.status === "success") {
          console.log("res status=======>", res);
          setMessage(res.message)
          setSnackbarStare(true);

          setUser(null);
          setLoader(false);

          setTimeout(function () {
            setNewwOpen(false);
        }, 3000);
          // setNewwOpen(false);
        } else {
          console.log("res error=======>", res);
          setMessage(res.message)
          setSnackbarStare(true);
          setLoader(false);
        }
      } catch (error) {
        console.log(error, "this is submit error");
        setLoader(false);
      }
      setLoader(false);
      // setUser(null)
      console.log("kjhkjh", user);
    }
  };

  // const RecaptchaComponent = dynamic(() => import("react-google-recaptcha"), {
  //   ssr: false,
  // });

  // const [token, setToken] = useState(null);

  // const handleCaptchaSubmission = async (e) => {
  //   console.log("eeeeeeeeeeeeeeeee", e);
  //   setToken(e);

  // };

  return (
    <>
      <div>
        <Modal
          open={newwOpen}
          onClose={handleNewwClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main banner_modal_main_new banner_modal_main_new1"
        >
          <div className="main_wrpr_finddivine"><span className="close_btn" onClick={handleNewwClose}>
                  <CloseIcon />
                </span>
          <Box className="banner_modal_box_new banner_modal_box_neww">
            <Typography
              id="modal-modal-description" component="div"
              sx={{ mt: 2 }}
              className="modal_banner_new"
            >

 
              <div className="sub_modal_banner_new">
                
                
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="bannerLogo" /> */}
                <div className="mdl_hdr">
                  <h2>
                    We have several professional diviners for both Astrology and
                    Tarot that are members of our school as well as graduates of
                    our programs. Starting in June 2024 we will have a search
                    for certified diviners available right here on our website!
                  </h2>
                </div>

                <div className="gred_txt">
                  <h3>
                    If you would please fill out the following information we
                    will connect you with one our our professional diviner{" "}
                    <span>
                      right away.
                      
                    </span>
                  </h3>
                </div>

                <div className="mdl_form_sec">
                  <form className="mdl_form">
                    <div className="mdl_form_flex">
                      <TextField
                        className="from_input form_field_wrapperfname"
                        id="outlined-basic"
                        name="firstname"
                        value={user?.firstname ? user.firstname : ""}
                        onChange={handleInput}
                        error={error.firstname ? true : false}
                        helperText={error.firstname}
                        onKeyDown={() => {
                          error.firstname = "";
                        }}
                        // label="Email*"
                        variant="outlined"
                        label="First Name"
                      />
                      <TextField
                        className="from_input form_field_wrapperstate"
                        id="outlined-basic"
                        name="lastname"
                        value={user?.lastname ? user.lastname : ""}
                        onChange={handleInput}
                        error={error?.lastname ? true : false}
                        helperText={error.lastname}
                        onKeyDown={() => {
                          error.lastname = "";
                        }}
                        // label="Email*"
                        variant="outlined"
                        label="Last Name"
                      />

                      <TextField
                        className="from_input"
                        id="outlined-basic"
                        name="email"
                        value={user?.email ? user.email : ""}
                        onChange={handleInput}
                        error={error.email ? true : false}
                        helperText={error.email}
                        onKeyDown={() => {
                          error.email = "";
                        }}
                        // label="Email*"
                        variant="outlined"
                        label="Email"
                      />

                      <TextField
                        label="Phone No"
                        className="from_input"
                        variant="outlined"
                        fullWidth={true}
                        name="phone"
                        type="text"
                        onKeyPress={(e) => {
                          error.phone = "";
                          // console.log("this is number onkeydown=====", e.code, e.key, 'e.which', e.which);
                          if (e.which < 48 || e.which > 57) {
                            e.preventDefault();
                          } else {
                            let input = e.target.value;
                            let result = input.replace(/\D/g, "");
                            console.log(input, result, "suyagudsa");
                          }
                        }}
                        onChange={(e) => phoneFormatting(e)}
                        value={user?.phone}
                        error={error?.phone ? true : false}
                        helperText={error?.phone}
                      />
                      <TextField
                        label="City"
                        className="from_input"
                        id="outlined-basic"
                        name="city"
                        value={user?.city ? user.city : ""}
                        onChange={handleInput}
                        error={error.city ? true : false}
                        helperText={error.city}
                        onKeyDown={() => {
                          error.city = "";
                        }}
                        // label="Email*"
                        variant="outlined"
                      />

                      <FormControl className="from_input form_field_wrapperstate">
                        <InputLabel id="demo-simple-select-helper-label">
                          Select State
                        </InputLabel>
                        <Select
                          className="contact_select_menu"
                          id="demo-simple-select-helper"
                          label="Select State"
                          name="state"
                          onChange={handleInput}
                          value={user?.state ? user.state : ""}
                          error={error.state ? true : false}
                          // value={user.select_taxonomy}
                          // onChange={handleInput}
                          // helperText={error.select_taxonomy}
                        >
                          {states.map((item, key) => {
                            return (
                              <MenuItem
                                className="contact_menu_item"
                                value={item.val}
                                key={key}
                              >
                                {item.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {error.state && (
                          <FormHelperText id="my-helper-text">
                            {error.state}
                          </FormHelperText>
                        )}
                      </FormControl>

                      <TextField
                        label="Zip"
                        className="from_input"
                        id="outlined-basic"
                        name="zip"
                        value={user?.zip ? user.zip : ""}
                        onChange={handleInput}
                        error={error.zip ? true : false}
                        helperText={error.zip}
                        onKeyDown={() => {
                          error.zip = "";
                        }}
                        // label="Email*"
                        variant="outlined"
                      />

                      <div className="from_input from_input_flx">
                        <span>Interested in</span>
                        <span className="chkbox chkboxyllw">
                          <FormControlLabel
                            onChange={(e) => handelCheckbox(e, "astrology")}
                            // value={interestValueTrue}
                            checked={interestValueTrue}
                            control={<Checkbox value="Astrology" />}
                            label="Astrology"
                            labelPlacement="start"
                          />
                          <FormControlLabel
                            onChange={(e) => handelCheckbox(e, "tarot")}
                            checked={interestValueFlase}
                            control={<Checkbox value="Tarot" />}
                            label="Tarot"
                            labelPlacement="start"
                            name="interested_in"
                          />
                          <FormControlLabel
                            onChange={(e) => handelCheckbox(e, "both")}
                            checked={interestValueBoth}
                            control={<Checkbox value="Both" />}
                            label="Both"
                            labelPlacement="start"
                          />
                        </span>
                        {user?.interested_in ? (
                          ""
                        ) : (
                          <FormHelperText id="my-helper-text">
                            {error?.interested_in && error.interested_in}
                          </FormHelperText>
                        )}
                      </div>

                      <div className="from_input_flx wdth100 from_input">
                        <span className="call_txt">Best time to call </span>
                        <span className="chkbox radiobox">
                          <FormControl>
                            <RadioGroup
                              aria-labelledby="demo-radio-buttons-group-label"
                              name="best_time_to_call"
                              onChange={handleInput}
                              value={
                                user?.best_time_to_call
                                  ? user.best_time_to_call
                                  : ""
                              }
                              className="radio_wrrp"
                            >
                              <FormControlLabel
                                value="Morning"
                                control={<Radio />}
                                label="Morning"
                                labelPlacement="start"
                                className="radio"
                              />
                              <FormControlLabel
                                value="Mid-day"
                                control={<Radio />}
                                label="Mid day"
                                labelPlacement="start"
                                className="radio"
                              />
                              <FormControlLabel
                                value="Evening"
                                control={<Radio />}
                                label="Evening"
                                labelPlacement="start"
                                className="radio"
                              />
                            </RadioGroup>
                          </FormControl>
                          {/* <FormControlLabel
                            onChange={bookingCallfunc}
                            value={bookingValue}
                            control={<Radio value="morning" />}
                            label="Morning"
                            labelPlacement="start"
                          />
                          <FormControlLabel
                            onChange={bookingCallfunc}
                            value={bookingValue}
                            control={<Radio value="midday" />}
                            label="Mid day"
                            labelPlacement="start"
                          />
                          <FormControlLabel
                            onChange={bookingCallfunc}
                            value={bookingValue}
                            control={<Radio value="evening" />}
                            label="Evening"
                            labelPlacement="start"
                          /> */}
                          {user?.best_time_to_call ? (
                            ""
                          ) : (
                            <FormHelperText id="my-helper-text">
                              {error?.best_time_to_call &&
                                error.best_time_to_call}
                            </FormHelperText>
                          )}
                        </span>
                        <div className="captcha_main">
                        <div className="reCaptcha_wrpr" style={{position:"relative"}}>
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={process.env.reCaptchaSite_key}
                            onChange={(e) => {
                              // console.log("eeee===>", e);
                              setTokenGen(e);
                              e.length>0 ? setError({...error, tokenGen: undefined }): setError({...error, tokenGen: "Prove you are not a robot" })
                            }}
                          />
                          <FormHelperText id="recaptchaid" style={{position: "absolute"}} className="captchaError">
                            {error.tokenGen}
                          </FormHelperText>
                        </div>
                        </div>
                      </div>
                    </div>

                    <div className="btn_wrpr">
                      <Button onClick={handleSubmit}>SUBMIT</Button>
                    </div>
                    {loader ? <LinearProgress /> : ""}
                    <div>
                   
                    <Snackbar
                      open={snackbarStare}
                      autoHideDuration={3000}
                      onClose={handleClose}
                      message= {message}
                      className="snack_msg"
                    />
                  </div>
                  </form>
                  
                </div>
              </div>
            </Typography>
          </Box>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default FindDivineModal;
